import React from 'react';
import MultiStepTraderRegistration from '../components/forms/MultiStepTraderRegistration';

const ProfessionalRegistration: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <MultiStepTraderRegistration />

    </div>
  );
};

export default ProfessionalRegistration;
